/**
 * Settings Screen - Information Dialog Actions
 *
 * Extracted from app/(tabs)/settings.tsx (Line Count Refactor 2025-11-21)
 *
 * Handles About, Privacy Policy, and Terms of Service dialogs.
 * Currently placeholders showing "coming soon" messages.
 *
 * Phase: 1B - Production Code Refactoring
 * Refactored: 2025-11-21 (settings.tsx: 345 → 172 lines)
 */

import { TFunc } from './types';

export interface InfoDialogsParams {
  alert: (title: string, message: string, buttons?: any[]) => void;
  t: TFunc;
  tCommon: TFunc;
}

/**
 * Shows About dialog (placeholder for future implementation)
 *
 * @param params Dialog parameters
 */
export function handleAbout(params: InfoDialogsParams): void {
  const { alert, t, tCommon } = params;

  alert(t('about.title'), t('about.coming_soon'), [{ text: tCommon('confirm') }]);
}

/**
 * Shows Privacy Policy dialog (placeholder for future implementation)
 *
 * @param params Dialog parameters
 */
export function handlePrivacy(params: InfoDialogsParams): void {
  const { alert, t, tCommon } = params;

  alert(t('privacy.title'), t('about.coming_soon'), [{ text: tCommon('confirm') }]);
}

/**
 * Shows Terms of Service dialog (placeholder for future implementation)
 *
 * @param params Dialog parameters
 */
export function handleTerms(params: InfoDialogsParams): void {
  const { alert, t, tCommon } = params;

  alert(t('terms.title'), t('about.coming_soon'), [{ text: tCommon('confirm') }]);
}
